import React from "react";
import "./Contact.css";
import Container from "react-bootstrap/Container";
import PetroImg from "./petro.png";
import DamianImg from "./damian.png";
import SebastianImg from "./sebastian.jpg";
import DarenImg from "./daren.jpg";
import ContactForm from "./ContactForm";

function Contact() {
  const testimonials = [
    {
      name: "Sebastian Raffo",
      role: "Lead Software Engineer",
      company: "Perkopolis",
      quote:
        "Dmitry is detail-oriented and proactive. He shipped mobile and web features with solid QA discipline and helped us keep releases stable while moving quickly on product updates.",
      image: SebastianImg,
    },
    {
      name: "Daren Wagar",
      role: "UX/UI Manager",
      company: "Perkopolis",
      quote:
        "Dmitry is easy to work with and consistently delivers polished UI that matches design intent. He moves quickly, asks the right questions, and makes collaboration feel effortless.",
      image: DarenImg,
    },
    {
      name: "Damian Krolevetsky",
      role: "Chief Technology Officer",
      company: "Uniwell Technologies",
      quote:
        "Dmitry consistently delivered clean, scalable React and Node work across multiple client builds. He took ownership of features, documented decisions, and was dependable in fast-moving, high-expectation environments.",
      image: DamianImg,
    },
    {
      name: "Petro Boyko",
      role: "Company Owner",
      company: "Food Link Delivery Ltd.",
      quote:
        "Dmitry built our food delivery site end-to-end and made the product feel smooth for real customers. He was quick to iterate on UX feedback, communicated clearly, and shipped a reliable React/Node/MongoDB stack in a tight window.",
      image: PetroImg,
    },
  ];

  return (
    <section className="contact sections" id="testimonials">
      <Container className="contact__container">
        <div className="contact__reviews">
          <div className="contact__reviews-header">
            <p className="contact__eyebrow">Reviews</p>
            <h2>What past teams say</h2>
            <p>Short notes from previous collaborators and managers.</p>
          </div>
          <div className="contact__reviews-grid">
            {testimonials.map((review) => (
              <article key={review.name} className="review-card">
                <div className="review-card__header">
                  <img
                    className="review-card__avatar"
                    src={review.image}
                    loading="lazy"
                    width="52" height="52"
                    alt={`${review.name} portrait`}
                  />
                  <div>
                    <h3>{review.name}</h3>
                    <p>
                      {review.role} - {review.company}
                    </p>
                  </div>
                </div>
                <blockquote className="review-card__quote">{review.quote}</blockquote>
              </article>
            ))}
          </div>
        </div>

        <div className="contact__info-panel" id="contact">
          <p className="contact__eyebrow">Contact</p>
          <h2>Get in touch</h2>
          <p>
            Interested in discussing a software engineering opportunity? Send me a
            message or connect with me on LinkedIn.
          </p>
          <div id="contact-form">
            <ContactForm
              className="contact__form-card--recruiter"
              title="Send a message"
              description="I’ll reply to the email address you provide."
              formSubject="New portfolio recruiting inquiry"
              formLabel="Portfolio contact form"
              secondaryFields={[]}
              showSubjectField={false}
              messagePlaceholder="Message*"
              submitLabel="Send Message"
            />
          </div>
          <div className="recruiter-actions contact__secondary-actions">
            <a href="https://www.linkedin.com/in/dmitry-kordik-b8410b19a/">LinkedIn</a>
            <a
              href="/resume/Dmitry-Kordik-Resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Resume
            </a>
            <a href="mailto:kordikmail@gmail.com">kordikmail@gmail.com</a>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Contact;
